// extracted by mini-css-extract-plugin
export default {"modalscreentitle":"ModalScreenTitle_modalscreentitle__IbAiQ"};